import React from "react";
import "./Dashboard.css";
import {Container} from "react-bootstrap";
import LiveChat from 'react-livechat';
import {mygaSession} from "../../scripts/myga-session";
import MygaRateBarChart from "./ResearchCenter/Charts/MygaRateBarChart";
import TreasuryNotesLineChart from "./ResearchCenter/Charts/TreasuryNotesLineChart";
import TreasuryBillsLineChart from "./ResearchCenter/Charts/TreasuryBillsLineChart";
import AppPageHeader from "../Application/AppPageHeader/AppPageHeader";
import MYGAStrings from "../../Resources/Content/MYGAStrings";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class RateCharts extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      mygaRates: [],
      bankRates: [],
      treasuryRates: []
    }
  }

  headerStyles = {
    backgroundColor: 'rgba(242, 193, 102, 0.25)',
    width: '100%',
    fontSize: '1.5em',
    marginTop: '20px'
  };

  subHeaderStyles = {
    fontSize: '1.3em'
  };

  chartItemStyles = {
    height: '250px',
    marginLeft: '10px',
    marginRight: '10px'
  };

  disclaimerStyles = {
    backgroundColor: 'rgba(200, 200, 200, .9)'
  };

  componentDidMount() {
    this.setState({
      mygaRates: mygaSession.getMygaRates(),
      bankRates: mygaSession.getBankRates(),
      treasuryRates: mygaSession.getTreasuryRates(),
      fullPageChart: null
    });
  }

  renderBankRates = (dataIsReady) => {
    return (
      <div style={{height: '100%'}}>
        <MygaRateBarChart mygaData={this.state.mygaRates}
                          bankData={this.state.bankRates}
                          dataIsReady={dataIsReady} />
      </div>
    )
  };

  renderTreasuryNotes = (duration, data, dataIsReady) => {
    return (
      <div style={{height: '100%'}}>
        <TreasuryNotesLineChart
          data={data}
          dataIsReady={dataIsReady}
          duration={duration}
          title={`Treasury Note (${duration})`}/>
      </div>
    )
  };

  renderTreasuryBills = (duration, data, dataIsReady) => {
    return (
      <div style={{height: '100%'}}>
        <TreasuryBillsLineChart
          data={data}
          dataIsReady={dataIsReady}
          duration={duration}
          title={`Treasury Bill (${duration})`}/>
      </div>
    )
  };

  renderTreasuryDisclaimers = () => {
    return (
      <div className={'disclaimer p-2'} style={{position: 'sticky', bottom: '0', ...this.disclaimerStyles}}>{MYGAStrings.LegalInfo_PubliclyAvailableInfo}</div>
    )
  };

  renderFullPageChart = chart => {
    return (
      <>
        <div style={{textAlign: 'right', marginRight: '1em', marginTop: '1em'}}>
          <FontAwesomeIcon icon={'times'} style={{cursor: 'pointer', position: 'relative'}}
                           onClick={() => this.setState({fullPageChart: null}, () => this.forceUpdate())}/>
        </div>
        <div style={{height: '100%'}}>
          {chart}
        </div>
      </>
    )
  };

  renderAllCharts = () => {
    return (
      <Container fluid className={'p-0'}>
        
        {/* 2025.12.23.ADivelbiss - commented since cdRates are not being updated. */}
        {/*<AppPageHeader fullPage headerLabel={'Rate Data'} updatePage={this.props.updatePage}/>*/}
        {/*<div style={{display: 'flex', flexWrap: 'wrap'}}>*/}
        {/*  <div className={'col col-md-6'}>*/}
        {/*    <div style={this.chartItemStyles} onClick={() => this.setFullPageChart(*/}
        {/*      <>*/}
        {/*        {this.renderFullPageChart(this.renderBankRates(true))}*/}
        {/*        <div className={'disclaimer p-3'} style={this.disclaimerStyles}>{MYGAStrings.LegalInfo_AnnuityCDRateInfo}</div>              </>*/}
        {/*      )}>*/}
        {/*      {this.renderBankRates(false)}*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
        
        {/*<div className={'disclaimer p-3'} style={this.disclaimerStyles}>{MYGAStrings.LegalInfo_AnnuityCDRateInfo}</div>*/}

        <AppPageHeader fullPage headerLabel={'Treasury Data'} updatePage={this.props.updatePage}/>
        {/*<AppPageHeader headerLabel={'Treasury Data'}/>*/}
        <div style={{display: 'flex', flexWrap: 'wrap'}}>
          <div className={'col col-md-6'}>
            <div style={this.chartItemStyles} onClick={() => this.setFullPageChart(
              <>
                {this.renderFullPageChart(this.renderTreasuryNotes('7-Year', this.state.treasuryRates, true))}
                {this.renderTreasuryDisclaimers()}
              </>
            )}>
              {this.renderTreasuryNotes('7-Year', this.state.treasuryRates, false)}
            </div>
          </div>

          <div className={'col col-md-6'}>
            <div style={this.chartItemStyles} onClick={() => this.setFullPageChart(
              <>
                {this.renderFullPageChart(this.renderTreasuryNotes('5-Year', this.state.treasuryRates, true))}
                {this.renderTreasuryDisclaimers()}
              </>
            )}>
              {this.renderTreasuryNotes('5-Year', this.state.treasuryRates, false)}
            </div>
          </div>

          <div className={'col col-md-6'}>
            <div style={this.chartItemStyles} onClick={() => this.setFullPageChart(
              <>
                {this.renderFullPageChart(this.renderTreasuryBills('26-Week', this.state.treasuryRates, true))}
                {this.renderTreasuryDisclaimers()}
              </>
            )}>
              {this.renderTreasuryBills('26-Week', this.state.treasuryRates, false)}
            </div>
          </div>

          <div className={'col col-md-6'}>
            <div style={this.chartItemStyles} onClick={() => this.setFullPageChart(
              <>
                {this.renderFullPageChart(this.renderTreasuryBills('13-Week', this.state.treasuryRates, true))}
                {this.renderTreasuryDisclaimers()}
              </>
              )}>
              {this.renderTreasuryBills('13-Week', this.state.treasuryRates, false)}
            </div>
          </div>

          {this.renderTreasuryDisclaimers()}
        </div>
      </Container>
    )
  };

  setFullPageChart = comp => {
    this.setState({fullPageChart: comp});
  };

  render() {

    let chartRender;
    if (this.state.fullPageChart) {
      chartRender = this.state.fullPageChart;
    } else {
      chartRender = this.renderAllCharts();
    }

    return (
      <Container className="overlay-background-color" fluid>
        <div className={'page-content-area dashboard-page'} align={'center'} style={{paddingBottom: '2em'}}>

          {chartRender}

        </div>

        <LiveChat license={11222357} group={2}/>

      </Container>

    );

  }
}

export default RateCharts;